import type { AdminProfile } from '../../../types'
import { DEFAULT_PROFILE } from '../constants'

const mergeNotifications = (
  current?: Partial<AdminProfile>['notifications'],
  incoming?: Partial<AdminProfile>['notifications'],
) => ({
  product: incoming?.product ?? current?.product ?? DEFAULT_PROFILE.notifications.product,
  marketing: incoming?.marketing ?? current?.marketing ?? DEFAULT_PROFILE.notifications.marketing,
  security: incoming?.security ?? current?.security ?? DEFAULT_PROFILE.notifications.security,
})

export const mergeProfile = (data?: Partial<AdminProfile>): AdminProfile => ({
  ...DEFAULT_PROFILE,
  ...(data ?? {}),
  notifications: mergeNotifications(undefined, data?.notifications),
})

export const mergeWithCurrentProfile = (current: AdminProfile, incoming?: Partial<AdminProfile>) =>
  mergeProfile({
    ...current,
    ...(incoming ?? {}),
    notifications: mergeNotifications(current.notifications, incoming?.notifications),
  })
